import { render, staticRenderFns } from "./MoreMenuitem.vue?vue&type=template&id=0c1783fd&"
import script from "./MoreMenuitem.vue?vue&type=script&lang=js&"
export * from "./MoreMenuitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports